import React from 'react';

import './DiscountProgramRegistration.scss';
import images from '../../shared/assets/images';

const { ideal } = images;

export default function DiscountProgramRegistration(props) {
  return (
    <section id="discountProgramRegistration">
      <h2>Lidmaatschap bevestigen</h2>

      <div id="discountProgramRegistration_content">
        <p>
          Je bent één stap verwijderd van je lidmaatschap van het Familie
          Voordeel Programma. Wij zetten in de tussentijd vast de beste
          voordelen voor je klaar
        </p>

        <p>
          Selecteer je betaalmethode voor de jaarlijkse bijdrage van 12,95 euro
          om toegang te krijgen tot alle voordelen van het Familie Voordeel
          Programma.
        </p>

        <div id="discountProgramRegistration_cost">
          <p>Jaarlijkse kosten:</p>

          <span>12,95</span>
        </div>

        <p>Beschikbare betaalmethode:</p>

        <ul id="discountProgramRegistration_payment_methods">
          <li data-method="ideal">
            <img src={ideal} alt="ideal" />
          </li>
        </ul>

        <a href={props.paymentLink}>
          <button>Bevestig en betaal</button>
        </a>
      </div>
    </section>
  );
}
